import React from 'react'
import { ChevronRight } from 'lucide-react'

// Flecha del botón que abre el menú lateral. Ignora las props de SvgIcon que manda DrawerMenuItem
// (htmlColor, fontSize) para que no lleguen al <svg>.
// eslint-disable-next-line no-unused-vars
const icon = ({ htmlColor, fontSize, ...props }) => <ChevronRight size={16} color="white" {...props} />

export default icon
